import { render } from "./responses-table-matching-menu.vue?vue&type=template&id=62b118ba&lang=pug"
import script from "./responses-table-matching-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./responses-table-matching-menu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__